<template>
  <div class="wrapper">
    <!-- Header section -->
    <section class="section-shaped section-lg my-0 section-header">
      <div class="shape shape-style-1 shape-primary">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg-md">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <h1 class="display-3 text-white text-center">Contact Us</h1>
            <p class="lead text-white text-center">Get in touch with the Zwapit team</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact form section -->
    <section class="section section-lg pt-lg-0 mt--100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <card class="border-0" shadow body-classes="py-5 px-5">
              <div class="row">
                <div class="col-lg-8 mx-auto text-center">
                  <h2 class="text-primary mb-5">Get in Touch</h2>
                  <form class="text-left">
                    <div class="form-group">
                      <label class="form-control-label font-weight-bold">Your Name</label>
                      <input type="text" class="form-control form-control-alternative" placeholder="Enter your name">
                    </div>
                    <div class="form-group">
                      <label class="form-control-label font-weight-bold">Email Address</label>
                      <input type="email" class="form-control form-control-alternative" placeholder="Enter your email">
                    </div>
                    <div class="form-group">
                      <label class="form-control-label font-weight-bold">Subject</label>
                      <input type="text" class="form-control form-control-alternative" placeholder="Enter subject">
                    </div>
                    <div class="form-group">
                      <label class="form-control-label font-weight-bold">Message</label>
                      <textarea rows="4" class="form-control form-control-alternative" placeholder="Enter your message"></textarea>
                    </div>
                    <div class="text-center">
                      <base-button type="primary" size="lg">Send Message</base-button>
                    </div>
                  </form>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ section -->
    <section class="section section-lg bg-gradient-default" style="padding-bottom: 13rem;">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3 text-white">Frequently Asked Questions</h2>
            <p class="lead text-white">Answers to common questions about Zwapit</p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <card class="border-0" shadow body-classes="px-5 py-5">
              <div class="mb-5">
                <h5 class="text-primary">Can I download Zwapit for free?</h5>
                <p class="mb-0">Yes, the Zwapit app is available for free on both iOS and Android devices.</p>
              </div>
              <div class="mb-5">
                <h5 class="text-primary">Do I need to pay to find an earlier driving test?</h5>
                <p class="mb-0">You do not need to pay to register or to search for an earlier test with Zwapit. These services are provided free of charge.</p>
              </div>
              <div class="mb-5">
                <h5 class="text-primary">Is my driving test booking information safe?</h5>
                <p class="mb-0">Yes, your details remain private unless you choose to share them with another user, in which case they will be visible only to them. We prioritize data security and use industry-standard encryption to safeguard all personal information and booking details.</p>
              </div>
              <div class="mb-5">
                <h5 class="text-primary">How many times can I swap my driving test?</h5>
                <p class="mb-0">The DVSA allows a maximum of 6 swaps. After reaching this limit, you'll need to cancel your test and book a new one to continue swapping.</p>
              </div>
              <div class="mb-5">
                <h5 class="text-primary">Where can I find information about the swapping process?</h5>
                <p class="mb-0">You can review our terms and conditions, where the steps to finalize an accepted swap are clearly outlined.</p>
              </div>
              <div>
                <h5 class="text-primary">Is there a fee for swapping a test?</h5>
                <p class="mb-0">You only need to pay if you choose to swap a test with another user. Once you accept the swap, it is considered a Match.</p>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>

    <!-- App Download CTA -->
    <section class="section section-lg pt-sm-0">
      <div class="container">
        <card class="card-profile shadow mt--150">
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-9 text-center">
                <h3 class="display-3">Download the Zwapit App</h3>
                <p class="lead">Get our mobile app and join thousands of learner drivers who have successfully swapped their tests using Zwapit.</p>
                <div class="row justify-content-center mt-5">
                  <div class="col-md-6 col-lg-4 mb-4">
                    <base-button block type="info" size="lg" class="btn-icon mb-3 m-auto download-btn">
                      <span class="btn-inner--icon"><img class="store-img" src="https://img.icons8.com/?size=100&id=30840&format=png&color=FFFFFF" alt="" style="margin-top: -4px;"></span>
                      <span class="btn-inner--text">App Store</span>
                    </base-button>
                  </div>
                  <div class="col-md-6 col-lg-4 mb-4">
                    <base-button block type="primary" size="lg" class="btn-icon mb-3 m-auto download-btn">
                      <span class="btn-inner--icon"><img class="store-img" src="https://img.icons8.com/?size=100&id=22982&format=png&color=FFFFFF" alt=""></span>
                      <span class="btn-inner--text">Google Play</span>
                    </base-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  components: {
    Card: () => import('@/components/Card')
  }
};
</script>

<style lang="scss">
.section-shaped {
  position: relative;
  overflow: hidden;

  .shape {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;

    &.shape-style-1 {
      span {
        position: absolute;
        
        &:nth-child(1) {
          bottom: -20px;
          left: -40px;
          width: 100px;
          height: 100px;
          opacity: 0.3;
          background: #017cfe;
          border-radius: 50%;
        }
        
        &:nth-child(2) {
          top: 10%;
          right: 10%;
          width: 150px;
          height: 150px;
          opacity: 0.2;
          background: #017cfe;
          border-radius: 50%;
        }
        
        &:nth-child(3) {
          top: 50%;
          right: 50%;
          width: 200px;
          height: 200px;
          background: rgba(1, 124, 254, 0.2);
          border-radius: 50%;
        }
        
        &:nth-child(4) {
          bottom: 50%;
          right: 10%;
          width: 300px;
          height: 300px;
          background: rgba(1, 124, 254, 0.15);
          border-radius: 50%;
        }
        
        &:nth-child(5) {
          bottom: 0;
          right: 0;
          width: 200px;
          height: 200px;
          background: rgba(1, 124, 254, 0.1);
        }
      }
    }

    &.shape-primary {
      background: linear-gradient(150deg, #015cbe 15%, #017cfe 70%, #56a8fe 94%);
    }
  }
}

.bg-gradient-default {
  background: linear-gradient(150deg, #015cbe 15%, #017cfe 70%, #56a8fe 94%) !important;
}

.text-primary {
  color: #017cfe !important;
}

.icon-shape-primary {
  background: linear-gradient(150deg, #015cbe 15%, #017cfe 70%, #56a8fe 94%) !important;
}
</style> 